import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { createRoot } from 'react-dom/client';

import { App } from './App';

class WebComponent extends HTMLElement {
    connectedCallback() {
        this.root = createRoot(this);

        this.root.render(
           <Router>
            <App
                contentStructureId={this.getAttribute('contentStructureId')}
                aniosCategoryId={this.getAttribute('aniosCategoryId')}
                showFirstOpen={this.getAttribute('showFirstOpen')}
            />
           </Router>
        , this);
    }

    disconnectedCallback() {
        this.root.unmount();
        delete this.root;
    }
}

const ELEMENT_ID = 'aena-retribuciones-bus-custom-element';

if (!customElements.get(ELEMENT_ID)) {
    customElements.define(ELEMENT_ID, WebComponent);
}